function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

class SideCart extends HTMLElement {
  constructor() {
    super();
    this.scrollCash();

    this.isOpen = false;

    this.addEventListener("cart:reload", this.refreshCart.bind(this));

    this.configVarsEvents(false);
    if (findGetParameter("open") == "cart") {
      this.openSideCart();
      // remove params from url
      history.pushState({}, document.title, window.location.pathname);
    }
    this.empty_cart = true;
    this.updateItemsHeight();

    window.addEventListener("resize", this.updateItemsHeight.bind(this));
  }

  disabledLinks(urls, attr, setAttr) {
    [...urls].forEach((url) => {
      url.setAttribute(attr, setAttr);
    });
  }

  blockedLinks(down) {
    const allLinks = document.querySelectorAll(".url-card");
    down
      ? this.disabledLinks(allLinks, "disabled", "disabled")
      : this.disabledLinks(allLinks, "disabled", "");
  }

  scrollCash() {
    const sliderTouch = document.querySelectorAll(".scroll-touch");
    let isDown = false;
    let startX;
    let scrollLeft;

    for (let slider of sliderTouch) {
      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
        this.blockedLinks(isDown);
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
        this.blockedLinks(isDown);
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        this.blockedLinks(isDown);
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  }

  updateItemsHeight() {
    let headerHeight = null;
    let uppselHeight = null;
    let footerHeight = null;
    let totalHeight = 0;
    this.querySelector(".side-cart__header")
      ? (headerHeight = this.querySelector(".side-cart__header").offsetHeight)
      : null;
    this.querySelector(".side-cart .side-cart-data-scrap__container")
      ? (footerHeight = this.querySelector(
        ".side-cart .side-cart-data-scrap__container"
      ).offsetHeight)
      : null;
    this.querySelector(".uppselllllll")
      ? (uppselHeight = this.querySelector(".side-cart__header").offsetHeight)
      : null;

    if (headerHeight != null) {
      totalHeight = totalHeight + headerHeight;
    }
    if (uppselHeight != null) {
      totalHeight = totalHeight + uppselHeight;
    }
    if (footerHeight != null) {
      totalHeight = totalHeight + footerHeight;
    }

    document.documentElement.style.setProperty(
      "--sidecart-items-height",
      `${totalHeight}px`
    );

    this.items = {};
  }

  configVarsEvents(is_open) {
    this.querySelector(".update-all__button")?.addEventListener(
      "click",
      this.updateAllSubscription.bind(this)
    );
    this.querySelectorAll(".sidecart-uppsells__navigation-item ").forEach(
      (elem) => {
        elem.addEventListener("click", this.toggleCollection.bind(this));
      }
    );

    this.querySelectorAll(".uppsels-add-to-cart").forEach((elem) => {
      elem.addEventListener("click", this.uppselAddToCart.bind(this));
    });

    this.sideCartContainer = document.getElementById("section-sidecart");

    this.openCartBtn = document.querySelector('[data-open="cart"]');
    this.closeCartBtn = document.querySelector(".side-cart__close-button");
    this.itemsCountSelector = document.querySelector("[data-cart-count]");
    this.openCartBtn.addEventListener("click", this.openSideCart.bind(this));
    this.closeCartBtn.addEventListener("click", this.closeSideCart.bind(this));
    this.addToCart = document.querySelectorAll("[data-side-variant-id]");
    this.querySelectorAll(".udpate-subscription").forEach((item) => {
      item.addEventListener("click", this.updateSubscription.bind(this));
    });
    this.isOpen = is_open;

    this.querySelectorAll(".update__selling-plan label").forEach((item) => {
      item.addEventListener("click", this.updateSellingPlanId.bind(this, item));
    });

    var cartForm = document.getElementById("SideCartForm");
    var that = this;

    if (document.querySelector("[add-to-cart]")) {
      document
        .querySelector("[add-to-cart]")
        .addEventListener("click", (event) => {
          event.preventDefault();
          this.addUpsell(event);
        });
    }

    document
      .querySelector("side-cart")
      .addEventListener("click", function (event) {
        var isClickInside = cartForm.contains(event.target);
        var isClickIcon = that.openCartBtn.contains(event.target);
        if (!isClickInside && !isClickIcon) {
          that.closeSideCart();
        }
      });

    this.addToCart.forEach((button) => {
      button.addEventListener("click", this.addToCartEvent.bind(this));
    });

    var minusQuantity = this.querySelectorAll(
      ".side-cart-item__quantity-minus"
    );
    var plusQuantity = this.querySelectorAll(".side-cart-item__quantity-plus");

    var removeItem = this.querySelectorAll("[data-remove-item]");

    minusQuantity.forEach((button) =>
      button.addEventListener("click", this.reduceQuantity.bind(this))
    );

    plusQuantity.forEach((button) =>
      button.addEventListener("click", this.addQuantity.bind(this))
    );

    removeItem.forEach((button) =>
      button.addEventListener("click", this.removeItem.bind(this))
    );

    setTimeout(function () {
      if (document.querySelector(".shopify-product-form")) {
        document
          .querySelector(".shopify-product-form")
          .addEventListener("opencart", (event) => {
            event.preventDefault();
            that.refreshCart();
          });
      }
    }, 1000);

    this.calculateShipping();
    if (document.querySelector(".cart-form__icon")) {
      this.calculateShippingCart();
    }
  }

  uppselAddToCart(e) {
    let currentId = e.currentTarget.dataset.variantId;

    const data = {
      items: [
        {
          id: currentId,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // add event submit on shopify-product-form to open the cart (tricks)
        document
          .querySelector("side-cart")
          .dispatchEvent(new Event("cart:reload"));
      });
  }

  toggleCollection(e) {
    let collectionHandle = e.currentTarget.dataset.collectionHandle;

    this.querySelectorAll(".sidecart-uppsells__navigation-item ").forEach(
      (elem) => {
        elem.classList.remove("actif");
      }
    );

    e.currentTarget.classList.add("actif");

    this.querySelectorAll(".sidecart-uppsells__collection").forEach((elem) => {
      elem.classList.add("hidden");
    });

    console.log(collectionHandle);

    this.querySelector(
      `[data-collection-show-handle="${collectionHandle}"]`
    ).classList.remove("hidden");
  }

  addToCartEvent(event) {
    event.preventDefault();
    var id = event.currentTarget.getAttribute("data-side-variant-id");
    this.updateQuantity(id, 1);
  }

  updateSubscription(event) {
    const elem = event.currentTarget;
    console.log(elem);
    const is_subscription = elem.querySelector("input").checked;

    if (is_subscription) {
      elem.querySelector("input").checked = false;
      elem
        .querySelector(".udpate-subscription__checkbox")
        .classList.remove("active");
      this.updateSellingPlan(elem, false);
    } else {
      elem.querySelector("input").checked = true;
      elem
        .querySelector(".udpate-subscription__checkbox")
        .classList.add("active");
      this.updateSellingPlan(elem, true);
    }
  }

  async updateAllSubscription(event) {
    const subscriptionItems = this.querySelectorAll(
      ".side-cart-item--subscribe"
    );
    const size = subscriptionItems.length;
    let i = 0;

    console.log(size);

    const updatePromises = Array.from(subscriptionItems).map((elem) => {
      return new Promise((resolve) => {
        const is_subscription = elem.querySelector(
          ".update-subscription__checkbox input"
        ).checked;

        if (!is_subscription) {
          elem.querySelector("input").checked = true;
          elem
            .querySelector(".update-subscription__checkbox")
            .classList.add("active");

          // Update selling plan if the subscription is enabled
          this.updateAllSellingPlanId(elem, true)
            .then(() => {
              resolve(); // Resolving once the async task is done
            })
            .catch((error) => {
              console.error("Error updating selling plan:", error);
              resolve(); // Continue even if there's an error
            });
        } else {
          resolve(); // Resolve immediately if already subscribed
        }

        i++;
        if (i === size) {
          console.log("Finished updating all subscriptions");
        }
      });
    });

    // Wait for all updates to complete
    await Promise.all(updatePromises);

    // Once all promises are resolved, refresh the cart
    this.refreshCart();
  }

  async updateAllSellingPlanId(elem) {
    const line = elem.closest("[data-cart-id]").getAttribute("data-line-item");
    const selling_plan_id = elem
      .querySelector(".update__selling-plan label")
      .getAttribute("for")
      .replace("selling_plan_side_", "");
    const quantity = parseInt(
      elem
        .closest(".side-cart-item")
        .querySelector("[data-quantity]")
        .getAttribute("data-quantity")
    );

    const url = "cart/change.js";
    const formData = {
      line: line,
      quantity: quantity,
      selling_plan: selling_plan_id,
    };

    console.log(
      "Updating selling plan for line:",
      line,
      "with plan:",
      selling_plan_id
    );

    try {
      const response = await fetch(window.Shopify.routes.root + url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const state = await response.json();
      console.log("Updated cart state:", state);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  calculateShipping() {
    if (this.querySelector(".sidecart-form__icon")) {
      // calculate shipping date from today + shipping delay exclude weekends
      let shipping_date = new Date(new Date().getTime());

      let shipping_delay = parseInt(
        this.querySelector(".sidecart-form__icon").getAttribute(
          "data-shipping-delay"
        )
      );
      if (shipping_delay == null) {
        shipping_delay = parseInt(
          this.querySelector(".cart-form__icon").getAttribute(
            "data-shipping-delay"
          )
        );
      }

      for (var i = 0; i < shipping_delay; i++) {
        shipping_date.setDate(shipping_date.getDate() + 1);
        if (shipping_date.getDay() == 6) {
          shipping_date.setDate(shipping_date.getDate() + 2);
        }
        if (shipping_date.getDay() == 0) {
          shipping_date.setDate(shipping_date.getDate() + 1);
        }
      }

      // get french date format day month year
      let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      for (
        let i = 0;
        i < document.querySelectorAll(".sidecart-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".sidecart-form__icon")[i]
          .innerHTML;
        if (html.indexOf("[date]") > -1) {
          document.querySelectorAll(".sidecart-form__icon")[i].innerHTML =
            html.replace("[date]", shipping_date_format);
        }
      }

      for (
        let i = 0;
        i < document.querySelectorAll(".cart-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".cart-form__icon")[i].innerHTML;
        if (html.indexOf("[date]") > -1) {
          if (document.querySelector(".cart-form__icon")) {
            document.querySelectorAll(".cart-form__icon")[i].innerHTML =
              html.replace("[date]", shipping_date_format);
          }
        }
      }
    }
  }
  calculateShippingCart() {
    if (this.querySelector(".cart-form__icon")) {
      // calculate shipping date from today + shipping delay exclude weekends
      let shipping_date = new Date(new Date().getTime());

      let shipping_delay = parseInt(
        this.querySelector(".cart-form__icon").getAttribute(
          "data-shipping-delay"
        )
      );

      for (var i = 0; i < shipping_delay; i++) {
        shipping_date.setDate(shipping_date.getDate() + 1);
        if (shipping_date.getDay() == 6) {
          shipping_date.setDate(shipping_date.getDate() + 2);
        }
        if (shipping_date.getDay() == 0) {
          shipping_date.setDate(shipping_date.getDate() + 1);
        }
      }

      // get french date format day month year
      let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      for (
        let i = 0;
        i < document.querySelectorAll(".cart-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".cart-form__icon")[i].innerHTML;
        if (html.indexOf("[date]") > -1) {
          document.querySelectorAll(".cart-form__icon")[i].innerHTML =
            html.replace("[date]", shipping_date_format);
        }
      }
    }
  }

  updateSellingPlanId(elem) {
    const line = elem.closest("[data-cart-id]").getAttribute("data-line-item");
    const selling_plan_id = elem
      .getAttribute("for")
      .replace("selling_plan_side_", "");
    console.log(selling_plan_id);
    const quantity = parseInt(
      elem
        .closest(".side-cart-item")
        .querySelector("[data-quantity]")
        .getAttribute("data-quantity")
    );
    var url = "cart/change.js";

    let formData = {
      line: line,
      quantity: quantity,
      selling_plan: selling_plan_id,
    };

    var that = this;

    fetch(window.Shopify.routes.root + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((state) => {
        console.log(state);
        that.refreshCart();
      })
      .catch((error) => {
        //ERROR
        console.log("Error : " + error);
      });
  }

  updateSellingPlan(elem, is_subscription) {
    const product_id = elem
      .querySelector("input")
      .getAttribute("data-product-id");
    const line = elem.querySelector("input").getAttribute("data-line");
    const selling_plan_id = ALLPRODUCTS_PLANS[product_id]["plans"][1];
    const quantity = parseInt(
      elem
        .closest(".side-cart-item")
        .querySelector("[data-quantity]")
        .getAttribute("data-quantity")
    );
    var url = "cart/change.js";

    let formData = {
      line: line,
      quantity: quantity,
      selling_plan: null,
    };

    if (is_subscription) {
      formData.selling_plan = selling_plan_id;
    }

    var that = this;

    fetch(window.Shopify.routes.root + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((state) => {
        console.log(state);
        that.refreshCart();
      })
      .catch((error) => {
        //ERROR
        console.log("Error : " + error);
      });
  }

  openSideCart() {
    if (window.innerWidth > 1024 && sidecart_desktop) {
      // check if we are on cart page by containing the cart page url
      if (document.querySelector("#section-cart")) {
        return;
      } else {
        window.location.href = "/cart";
        return;
      }
    } else {
      console.log("openSideCart");

      this.isOpen = true;
      document.querySelector("body").classList.add("overflow-hidden-cart");
      this.sideCartContainer.classList.add("side-cart--open");
      this.sideCartContainer.classList.add("side-cart--indexed");
    }
  }

  closeSideCart() {
    console.log("closeSideCart");
    if (this.isOpen) {
      this.isOpen = false;
      document.querySelector("body").classList.remove("overflow-hidden-cart");
      this.sideCartContainer.classList.remove("side-cart--open");
      this.sideCartContainer.classList.remove("side-cart--indexed");
    }
  }

  addQuantity(event) {
    event.preventDefault();
    var line_item = event.target.closest("[data-quantity]");
    var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
    var variant_id = line_item.getAttribute("data-variant-id");
    var new_quantity = actual_quantity + 1;

    line_item.setAttribute("data-quantity", new_quantity);
    line_item.querySelector(
      ".side-cart-item__quantity-selector span + span"
    ).innerHTML = new_quantity;
    this.updateQuantity(variant_id, new_quantity);
  }

  reduceQuantity(event) {
    event.preventDefault();
    var line_item = event.target.closest("[data-quantity]");
    var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
    var variant_id = line_item.getAttribute("data-variant-id");
    var new_quantity = actual_quantity - 1;

    line_item.setAttribute("data-quantity", new_quantity);
    line_item.querySelector(
      ".side-cart-item__quantity-selector span"
    ).innerHTML = new_quantity;

    this.updateQuantity(variant_id, new_quantity);
  }

  removeItem(event) {
    event.preventDefault();
    this.updateQuantity(
      event.currentTarget.getAttribute("data-remove-item"),
      0
    );
  }

  updateQuantity(line, quantity) {
    var url = "/cart/update.js";
    const update_label = "updates[" + line + "]=" + quantity;
    const body = update_label;

    fetch(url, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body,
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.refreshCart();
      })
      .catch(() => { });
  }

  refreshCart() {
    fetch("/cart?view=json")
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          alert(
            "Error : Refresh cart has a problem. If you see this error please contact us."
          );
        }
      })
      .then((response) => {
        var btn_checkout = document.querySelector(
          ".v2-button.checkout"
        ).innerHTML;
        var empty =
          '<div class="side-cart__cart-empty text-center">' +
          document.querySelector(".side-cart__cart-empty").innerHTML +
          "</div>";
        const subtitle_btn = document.querySelector(".side-cart__checkout-info")
          ? document.querySelector(".side-cart__checkout-info").innerHTML
          : "";

        let icons_text = document.querySelector(".sidecart-icons");
        let icons_paye = document.querySelector(".sidecart-icons-paye");

        icons_text = icons_text ? icons_text.innerHTML : false;
        icons_paye = icons_paye ? icons_paye.innerHTML : false;

        document.querySelector(".side-cart__inner").innerHTML = response;
        document.querySelector(".side-cart__inner").innerHTML += empty;

        var nb_items = document
          .querySelector("[data-products]")
          .getAttribute("data-nb-items");
        document.querySelectorAll("[data-cart-count]").forEach((item) => {
          item.innerHTML = nb_items;
        });
        nb_items > 0
          ? document.querySelectorAll("[data-cart-count]").forEach((item) => {
            item.classList.remove("hidden");
          })
          : document.querySelectorAll("[data-cart-count]").forEach((item) => {
            item.classList.add("hidden");
          });

        document.querySelector(".v2-button.checkout")
          ? (document.querySelector(".v2-button.checkout ").innerHTML =
            btn_checkout)
          : null;

        // document.querySelector(".side-cart__checkout-info")?.innerHTML =
        //   subtitle_btn;

        if (response.indexOf("no-product") > -1) {
          document.querySelector("[data-products]").classList.add("hidden");
          document
            .querySelector("#SideCartForm")
            .classList.add("sidecart--empty");
          document
            .querySelector(".side-cart__inner")
            .classList.add("side-cart__inner-empty");
          document
            .querySelector(".side-cart__cart-empty")
            .classList.remove("hidden");
          this.empty_cart = true;
        } else {
          document.querySelector("[data-products]").classList.remove("hidden");
          document
            .querySelector(".side-cart__cart-empty")
            .classList.add("hidden");
          document
            .querySelector(".side-cart__inner")
            .classList.remove("side-cart__inner-empty");
          document
            .querySelector("#SideCartForm")
            .classList.remove("sidecart--empty");
          this.empty_cart = false;
        }

        if (!document.querySelector("#section-cart")) {
          this.configVarsEvents(true);
        }

        var cart_is_open = document
          .querySelector(".side-cart")
          .classList.contains("side-cart--open");
        if (document.querySelector(".product-form__cart-submit")) {
          document
            .querySelector(".product-form__cart-submit")
            .removeAttribute("aria-disabled");
        }

        if (icons_text) {
          // insert icons_text after .side-cart-data-scrap
          document
            .querySelector(".side-cart-data-scrap")
            .insertAdjacentHTML(
              "afterend",
              '<div class="sidecart-icons">' + icons_text + "</div>"
            );
        }

        this.updateFreeShipping();

        if (!cart_is_open) {
          this.openSideCart();
        }
      })
      .catch((error) => {
        alert(
          "Error : Refresh cart has a problem. If you see this error please contact us.\n" +
          error
        );
      });

    console.log(window.Shopify.routes.root);

    if (document.querySelector("#section-cart")) {
      fetch("/cart?view=template")
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          console.log(doc);

          const newCart = doc.querySelector("#cart_page");

          console.log("newCart", newCart);

          document.querySelector("#cart_page").innerHTML = newCart.innerHTML;
          this.configVarsEvents(true);

          setTimeout(() => {
            this.calculateShipping();
          }, 1000);
        });
    }
  }

  updateFreeShipping() {
    const current_total = parseFloat(
      document
        .querySelector("[data-subtotal]")
        .innerHTML.replace(",", ".")
        .replace("€", "")
        .replace(" ", "")
    ).toFixed(2);

    const min_free_shipping = parseFloat(
      document
        .querySelector("[data-freeshipping-min]")
        .dataset.freeshippingMin.replace(",", ".")
        .replace("€", "")
        .replace(" ", "")
    ).toFixed(2);

    let is_free = parseFloat(current_total) >= parseFloat(min_free_shipping);
    let rest = min_free_shipping - current_total;
    let percentage = (current_total / min_free_shipping) * 100;

    console.log(min_free_shipping + " " + current_total + " " + is_free);

    if (document.querySelector(".udpate-subscription__checkbox.active")) {
      is_free = true;
      percentage = 100;
    }

    let percentageMax = percentage >= 100 ? 100 : percentage.toFixed(0);
    if (this.empty_cart) {
      percentageMax = 0;
      document.querySelectorAll("[data-ship-rest]").forEach((elem) => {
        elem.innerHTML = min_free_shipping;
      });
    } else {
      document.querySelectorAll("[data-ship-rest]").forEach((elem) => {
        elem.innerHTML = rest > 0 ? rest.toFixed(2) : 0;
      });
    }

    document
      .querySelectorAll(".sidecart__shipping-progress__bar__fill")
      .forEach((elem) => {
        elem.style = `width: ${percentageMax}%;`;
      });

    switch (is_free) {
      case true:
        document
          .querySelectorAll("[data-shipping-not-complete]")
          .forEach((elem) => {
            elem.classList.add("hidden");
          });

        document
          .querySelectorAll("[data-shipping-complete]")
          .forEach((elem) => {
            elem.classList.remove("hidden");
          });
        break;
      case false:
        document
          .querySelectorAll("[data-shipping-not-complete]")
          .forEach((elem) => {
            elem.classList.remove("hidden");
          });
        document
          .querySelectorAll("[data-shipping-complete]")
          .forEach((elem) => {
            elem.classList.add("hidden");
          });
        break;
    }
  }

  addUpsell(e) {
    const variant_id = e.currentTarget.getAttribute("add-to-cart");

    const data = {
      items: [
        {
          id: variant_id,
          quantity: 1,
          properties: {
            _offered: "true",
          },
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // add event submit on shopify-product-form to open the cart (tricks)
        this.refreshCart();
      });
  }

  addItemSimple(e) {
    e.preventDefault();
    const variant_id = e.currentTarget.getAttribute("data-variant-id-simple");

    const data = {
      items: [
        {
          id: variant_id,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // add event submit on shopify-product-form to open the cart (tricks)
        this.refreshCart();
      });
  }
}

customElements.define("side-cart", SideCart);

window.addEventListener("load", function () {
  document
    .querySelectorAll("form button[data-variant-id-simple]")
    .forEach((button) => {
      button.addEventListener("click", function (e) {
        addItemSimple(e);
      });
    });
});

function addItemSimple(e) {
  e.preventDefault();
  const variant_id = e.currentTarget.getAttribute("data-variant-id-simple");

  const data = {
    items: [
      {
        id: variant_id,
        quantity: 1,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // add event submit on shopify-product-form to open the cart (tricks)
      document
        .querySelector("side-cart")
        .dispatchEvent(new Event("cart:reload"));
    });
}

class nextDelivery extends HTMLElement {
  constructor() {
    super();
    this.month = parseInt(this.getAttribute("data-month"));
    const date = new Date();
    date.setMonth(date.getMonth() + this.month);
    this.querySelector(
      "span"
    ).textContent = `Prochain renouvellement aura lieu le ${date.toLocaleDateString(
      "fr-FR",
      {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    )}`;
  }
}

customElements.define("next-delivery", nextDelivery);
